(function (root,factory) {
  var api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(root)root.DSDOriginalsRoutes=api;
})(typeof window!=='undefined'?window:null,function () {
  'use strict';
  var SERIES='just-the-homie';
  var CHAPTER_IDS=['chapter-01','chapter-02','chapter-03','chapter-04','chapter-05','chapter-06','chapter-07','chapter-08'];
  function mapped(routes,type,chapterId) {
    if(type!=='series'&&CHAPTER_IDS.indexOf(chapterId)===-1)return null;
    var value=type==='series'?routes&&routes.series:routes&&routes.chapters&&routes.chapters[chapterId];
    var suffix=type==='series'?'':'-'+chapterId;
    var pattern=new RegExp('^/(?:[a-z]{2}(?:-[a-z0-9]+)?/)?pages/dsd-originals-just-the-homie'+suffix+'/?$','i');
    return typeof value==='string'&&pattern.test(value)?value:null;
  }
  function publicPath(pathname,routes) {
    return typeof pathname==='string'&&(pathname===mapped(routes,'series')||CHAPTER_IDS.some(function(id){return pathname===mapped(routes,'chapter',id);}));
  }
  function parse(search,pathname,routes) {
    var params=new URLSearchParams(search||'');
    if(!params.has('view')) {
      if(pathname&&pathname===mapped(routes,'series'))return {view:'series',seriesId:SERIES,chapterId:''};
      for(var index=0;index<CHAPTER_IDS.length;index+=1){
        if(pathname&&pathname===mapped(routes,'chapter',CHAPTER_IDS[index]))return {view:'chapter',seriesId:SERIES,chapterId:CHAPTER_IDS[index]};
      }
    }
    var view=params.get('view');
    if(['home','series','chapter'].indexOf(view)===-1)view='home';
    return {view:view,seriesId:params.get('series')||'',chapterId:params.get('chapter')||''};
  }
  function href(route,routes) {
    var view=['home','series','chapter'].indexOf(route.view)===-1?'home':route.view;
    var path=route.seriesId===SERIES&&view!=='home'?mapped(routes,view,route.chapterId):null;
    if(path)return path;
    // Internal home is the library panel; the storefront entry uses view=library.
    var params=new URLSearchParams();params.set('view',view==='home'?'library':view);
    if(route.seriesId)params.set('series',route.seriesId);
    if(view==='chapter'&&route.chapterId)params.set('chapter',route.chapterId);
    return '/?'+params.toString();
  }
  function read(node) {
    try {var value=JSON.parse(node&&node.textContent||'{}');return value&&typeof value==='object'&&!Array.isArray(value)?value:{};}catch(error){return {};}
  }
  return {parse:parse,href:href,publicPath:publicPath,read:read};
});
